import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { showToast, getData, putData, deleteData, postData } from "Source/globalFunction";
import { DeleteModal } from "Source/globalComponents";
import ProjectMemberForm from "./Member/Member";
import General from "./General/General";
import Workstreams from "./Workstreams/Workstreams";
import AddWorkstream from "Components/workstream/modal/AddWorkstream/AddWorkstream";
import Calendar from "../Calendar/Calendar";
import NavigationBLocker from "Components/common/NavigationBlocker/NavigationBlocker"
import DiscardChanges from "./Modal/DiscardChanges/DiscardChanges";
import Inbox from "../Inbox/Inbox";
import Dashboard from "../Dashboard/Dashboard";

let keyTimer = "";

@connect(store => {
    return {
        project: store.project,
        loggedUser: store.loggedUser,
        status: store.status,
        type: store.type,
        users: store.users,
        teams: store.teams,
        members: store.members,
        document: store.document,
        settings: store.settings
    };
})
export default class ProjectForm extends React.Component {
    constructor(props) {
        super(props);
           this.state={
               hasChanges:{},
               onEdit:null,
               isOnEdit:null
        }
        _.map(["handleChange",
            "handleSubmit",
            "setDropDown",
            "handleCheckbox",
            "renderArrayTd",
            "confirmDelete",
            "handleColorSlider",
            "onDrop", "upload",
            "setProjetLeadList",
            "getProjectFormSelectList",
            "handleEditChanges",
            "discardCancel",
            "triggerEdit"
        ], fn => {
            this[fn] = this[fn].bind(this);
        });
    }

    componentDidMount() {
        const { dispatch, project } = this.props;

        getData(`/api/project/getProjectTeams?linkId=${project.Selected.id}&linkType=project&usersType=team`, {}, c => {

            dispatch({ type: "SET_TEAM_LIST", list: c.data });
            dispatch({ type: "SET_PROJECT_FILTER", filter: { ["typeId"]: 1 } });
        });

        this.getProjectFormSelectList();
        this.fetchProjetLeadList();
       
    }
     
shouldComponentUpdate(nextProps){

    if(!_.isEqual(nextProps.scrollId, this.props.scrollId) && nextProps.scrollId) {
        if(this.refs[nextProps.scrollId]) {
            setTimeout(() => {
                this.refs[nextProps.scrollId].scrollIntoView() 
            }, 100);
        }
    }
    return true
}
    
 

getProjectFormSelectList() { 
    const { dispatch } = this.props;
    getData(`/api/type`, {}, c => {
        dispatch({ type: "SET_TYPE_LIST", list: c.data });
        
    });
}


    componentWillUnmount() {
        const { dispatch } = this.props;
        dispatch({ type: "SET_WORKSTREAM_SELECTED", Selected: {} });
        dispatch({ type: "SET_TEAM_LIST", list: [], count: {} });
        dispatch({ type: "SET_MEMBERS_LIST", list: [], count: {} });
    }

    deleteMember(value) {
        const { dispatch } = this.props;
        dispatch({ type: "SET_MEMBERS_SELECTED", Selected: { ...value, action: "delete" } });
        $(`#delete-member`).modal("show");
    }

    confirmDelete() {
        const { members, project, dispatch } = this.props;
        const { id, member_type, member_type_id } = members.Selected;

        deleteData(`/api/project/deleteProjectMember/${id}?project_id=${project.Selected.id}&member_type=${member_type}&member_type_id=${member_type_id}`, {}, c => {
            if (c.status === 200) {
                if (member_type === "User") {
                    const currentMember = _.filter(project.Selected.members, o => {
                        return o.member_id !== id;
                    });
                    dispatch({ type: "SET_PROJECT_SELECTED", Selected: { ...project.Selected, members: currentMember } });
                } else {
                    const currentTeam = _.filter(project.Selected.team, o => {
                        return o.team.id !== member_type_id;
                    });
                    dispatch({ type: "SET_PROJECT_SELECTED", Selected: { ...project.Selected, team: currentTeam } });
                }

                showToast("success", "Successfully Deleted");
            } else {
                showToast("error", c.data.message, 360000);
            }
        });
        dispatch({ type: "SET_MEMBERS_SELECTED", Selected: {} });
        $(`#delete-member`).modal("hide");
    }

    handleChange(e) {
        const { dispatch, project } = this.props;
        let Selected = Object.assign({}, project.Selected);

        this.setState({
            currentProjectManager: Selected.leadId
        });

        Selected[e.target.name] = e.target.value;
        dispatch({ type: "SET_PROJECT_SELECTED", Selected: Selected });
    }

    handleCheckbox(name, value) {
        let { dispatch, project } = this.props;
        let Selected = Object.assign({}, project.Selected);
        Selected[name] = value;
        if (name === "appNotification" && !value) {
            Selected["emailNotification"] = false;
        }
        dispatch({ type: "SET_PROJECT_SELECTED", Selected: Selected });
    }

    handleSubmit(e) {
        const { project, loggedUser, dispatch } = this.props;
        let result = true;
        $("#project-form *").validator("validate");
        $("#project-form .form-group").each(function () {
            if ($(this).hasClass("has-error")) {
                result = false;
            }
        });

        if (!result) {
            showToast("error", "Please fill up the required fields.");
        } else {
            dispatch({type: "SET_SCREEN_LOADER", Loading: true});
            if (!project.Selected.id) {
               
                project.Selected.createdBy = loggedUser.data.id;
                postData(`/api/project`, { ...project.Selected }, c => {
                    if (c.data.error) {
                        showToast("error", c.data.message);
                    } else {
                        showToast("success", "Project successfully added.");
                        dispatch({
                            type: "SET_PROJECT_SELECTED",
                            Selected: {
                                ...c.data.project,
                                members: _.map(c.data.members, (u) => {
                                    return {...u.user, memberType: u.memberType};
                                })
                            }
                        });
                        dispatch({
                            type: "SET_MEMBERS_LIST",
                            list: _.map(c.data.members, (u) => {
                                return {...u.user, memberType: u.memberType};
                            })
                        });
                        dispatch({
                            type: "SET_PROJECT_CATEGORY",
                            data: { list: [...project.Category[c.data.project.type.type].list, ...[c.data.project]], count: project.Category[c.data.project.type.type].count },
                            category: c.data.project.type.type
                        });
                        dispatch({type: "SET_SCREEN_LOADER", Loading: false});
                    }
                });
            } else {
                const dataToSubmit = {
                    project: project.Selected.project,
                    isActive: project.Selected.isActive,
                    typeId: project.Selected.typeId,
                    tinNo: project.Selected.tinNo,
                    companyAddress: project.Selected.companyAddress,
                    classification: project.Selected.classification,
                    projectNameCount: project.Selected.projectNameCount,
                    projectType: project.Selected.projectType,
                    groupEmail: project.Selected.groupEmail,
                    projectManagerId: project.Selected.projectManagerId,
                    leadId: project.Selected.leadId,
                    color: project.Selected.color,
                    updatedBy: loggedUser.data.id,
                    dateUpdated: moment().format("YYYY-MM-DD HH:mm:ss"),
                    appNotification: project.Selected.appNotification,
                    emailNotification: project.Selected.emailNotification
                };
                putData(`/api/project/${project.Selected.id}`, dataToSubmit, c => {
                    if(c) {
                        dispatch({
                            type: "SET_PROJECT_SELECTED",
                            Selected: {
                                ...project.Selected,
                                ...c.data.project,
                                members: _.map(c.data.members, (m) => {
                                    return {...m, ...m.user, member_id: m.id, memberType: m.memberType};
                                })
                            }
                        });

                        showToast("success", "Successfully Updated.");
                    }
                    
                    dispatch({type: "SET_SCREEN_LOADER", Loading: false});
                });
            }
           
        }
    }

    // Not used anymore
    setDropDown(name, value) {
        const { dispatch, project, members, loggedUser } = this.props;
        const Selected = Object.assign({}, project.Selected);

        if (name === "projectManagerId" && value !== "") {
            if (value !== project.ProjectManagerId) {
                let newMemberList = members.List.filter(e => {
                    return e.id !== project.ProjectManagerId;
                });
                dispatch({ type: "SET_PROJECT_MANAGER_ID", id: name });
                dispatch({ type: "SET_MEMBERS_LIST", list: newMemberList });
            }
        }
        if (name === "typeId" && value === 3) {
            Selected["projectManagerId"] = loggedUser.data.id;
        }
        Selected[name] = value;
        dispatch({ type: "SET_PROJECT_SELECTED", Selected: Selected });
    }

    setDropDownMultiple(name, values) {
        this.setState({
            [name]: JSON.stringify(values ? values : [])
        });
    }

    renderArrayTd(arr) {
        return arr.join("\r\n");
    }

    renderRoles(value) {
        return _.map(value, valueObj => {
            return valueObj.role.role;
        }).join("\r\n");
    }

    handleColorSlider(e) {
        const { dispatch, project } = this.props;
        const { Selected } = project;
        dispatch({ type: "SET_PROJECT_SELECTED", Selected: { ...Selected, color: e.hex } });
    }

    onDrop(picture) {
        const { dispatch } = this.props;
        dispatch({ type: "SET_DOCUMENT_FILES", Files: picture });
    }

    upload() {
        const { document, project, dispatch } = this.props;
        const { Selected } = project;
        let data = new FormData();

        dispatch({ type: "SET_DOCUMENT_LOADING", Loading: "SUBMITTING" });
        _.map(document.Files, file => {
            data.append("file", file);
            data.append("project_id", project.Selected.id);
        });

        postData(`/api/project/upload?projectId=${project.Selected.id}`, data, c => {
            dispatch({ type: "SET_DOCUMENT_LOADING", Loading: "" });
            dispatch({ type: "SET_DOCUMENT_FILES", Files: "" });
            dispatch({ type: "SET_PROJECT_SELECTED", Selected: { ...Selected, picture: c.data } });
            showToast("success", "Project picture successfully uploaded.");

            $("#upload-picture").modal("hide");
        });
    }

    setProjetLeadList(options) {
        keyTimer && clearTimeout(keyTimer);
        keyTimer = setTimeout(() => {
            this.fetchProjetLeadList(options);
        }, 1500);
    }

    fetchProjetLeadList(options) {
        const { dispatch, loggedUser } = this.props;
        let fetchUrl = "/api/user?page=1&isDeleted=0&type=teamLead";

        if (typeof options !== "undefined" && options !== "") {
            fetchUrl += `&name=${options}`;
        }

        getData(fetchUrl, {}, c => {
            let projectLeadList = _(c.data.result)
                .map(e => {
                    return { id: e.id, name: e.firstName + " " + e.lastName, image: e.avatar };
                })
                .value();

            let hasLoggedUser = _.find(projectLeadList, { id: loggedUser.data.id });
            if (!hasLoggedUser && loggedUser.data.userRole <= 3) {
                projectLeadList.push({ id: loggedUser.data.id, name: `${loggedUser.data.firstName} ${loggedUser.data.lastName}`, image: loggedUser.data.avatar });
            }
            dispatch({ type: "SET_USER_SELECT_LIST", List: projectLeadList });
        });
    }

    handleSelectProjectMemberStatus(field, value) {
        const { dispatch, project } = this.props;

        dispatch({ type: "SET_MEMBER_FILTER", filter: { [field]: value } });

        let requestUrl = `/api/project/detail/${project.Selected.id}?info=${1}&action=edit&memberStatus=${value}`

        getData(requestUrl, {}, c => {
            if (c.data) {
                dispatch({ type: "SET_PROJECT_SELECTED", Selected: { ...project.Selected, ...c.data } });
                dispatch({ type: "SET_PROJECT_MANAGER_ID", id: project.Selected.projectManagerId });
                dispatch({ type: "SET_PROJECT_FORM_ACTIVE", FormActive: "Form" });
            } else {
                window.location.href = "/account#/inactive-project";
            }
        });
    }
    handleEditChanges(param){
        let obj = this.state.hasChanges
        Object.assign(obj, param)
       this.setState({hasChanges:obj})
    }
    discardCancel() {
        this.setState({ isOnEdit: this.state.onEdit })
        $('#accountSetting').modal("hide")
    }
    triggerEdit(param) {
        let obj = Object.keys(param)[0]
        let val = Object.values(param)[0]
        if(val !== undefined) {
            this.setState({ onEdit: obj})
        }
       
    }
    render() {
        const { dispatch, project, loggedUser, status, type, users, document, members, settings, showHeader= true } = this.props;
        const { Files, Loading: documentLoading } = document;
        const typeValue = typeof members.Selected !== "undefined" && _.isEmpty(members.Selected) === false ? members.Selected.name : "";
        const memberList = [
            ..._.map(project.Selected.members, ({ firstName, lastName, member_id, id, emailAddress, isActive }) => {
                return {
                    id: member_id,
                    name: firstName + " " + lastName,
                    member_type: "User",
                    member_type_id: id,
                    email: emailAddress,
                    active: isActive
                };
            }),
            ..._.map(project.Selected.team, ({ id, team, isActive }) => {
                return {
                    id: id,
                    name: team.team,
                    member_type: "Team",
                    member_type_id: team.id,
                    users_team: team.users_team,
                    active: isActive
                };
            })
        ];
        let projectManagerOptions = users.SelectList;
        let statusList = [];
        let  typeList = [];

        status.List.map((e, i) => {
            if (e.linkType === "project") {
                statusList.push({ id: e.id, name: e.status });
            }
        });
        typeList = _(type.List)
            .filter((/*{ linkType, type }*/ data) => {
                if (loggedUser.data.userRole === 4) {
                    return data.type === "Private" || data.type === "Internal";
                } else {
                    return data.linkType === "project";
                }
            })
            .map((/*{ id, type }*/ value) => {
                return { id: value.id, name: value.type };
            })
            .value();

        if (typeof project.Selected.id !== "undefined" && project.Selected.id !== "") {
            projectManagerOptions = _.uniqBy(
                [
                    ...projectManagerOptions,
                    ..._(project.Selected.members)
                        .filter(({ id }) => {
                            return id === project.Selected.leadId;
                        })
                        .map(e => {
                            return {
                                id: e.id,
                                name: e.firstName + " " + e.lastName,
                                image: e.avatar
                            };
                        })
                        .value()
                ],
                "id"
            );
        }
      const hasChanges = Object.keys(this.state.hasChanges).filter(f=>this.state.hasChanges[f])
     const isOpen =this.state.onEdit
     const isInternal = typeof project.Selected.id !== "undefined" 
        && (loggedUser.data.userRole <= 3 || (loggedUser.data.userRole === 4 && (project.Selected.type.type === "Private" || project.Selected.type.type === "Internal")));

    const hasEdit = typeof project.Selected.id !== "undefined" 
        && loggedUser.data.userRole <= 3;
        
        return (
            <div class="row account-details-container">
                <div class="col-lg-12 pd0">
                    <div class="card form-card">
                        <div class="card-body">
                            <div ref='general'>
                                <General 
                                editChange={this.handleEditChanges}  
                                hasChanges={this.state.hasChanges}
                                triggerEdit={this.triggerEdit}
                                isEdit={this.state.isOnEdit}
                                isOpen={isOpen}
                                onCancel={()=>{this.setState({onEdit:null})}}
                                selected={project.Selected}
                                allowEdit={hasEdit}
                                 />
                            </div>
                            {isInternal &&
                                <div ref='dashboard'>
                                    <Dashboard 
                                        editChange={this.handleEditChanges}  
                                        hasChanges={this.state.hasChanges}
                                        triggerEdit={this.triggerEdit}
                                        isEdit={this.state.isOnEdit}
                                        isOpen={isOpen}
                                        onCancel={()=>{this.setState({onEdit:null})}}
                                    />
                                </div>
                            }
                            <div ref='inbox'>
                                <Inbox 
                                    editChange={this.handleEditChanges}  
                                    hasChanges={this.state.hasChanges}
                                    triggerEdit={this.triggerEdit}
                                    isEdit={this.state.isOnEdit}
                                    isOpen={isOpen}
                                    onCancel={()=>{this.setState({onEdit:null})}}
                                 />
                            </div>
                            <div id='members' ref='members'>
                                {typeof project.Selected.id !== "undefined" && (loggedUser.data.userRole <= 3 || (loggedUser.data.userRole === 4 && (project.Selected.type.type === "Private" || project.Selected.type.type === "Internal"))) && (
                                    <ProjectMemberForm  
                                    editChange={this.handleEditChanges}
                                    hasChanges={this.state.hasChanges}
                                    triggerEdit={this.triggerEdit} 
                                    isEdit={this.state.isOnEdit}
                                    isOpen={isOpen}
                                    onCancel={()=>{this.setState({onEdit:null})}}
                                    />
                                )}
                            </div>
                            <div id="workstreams" ref='workstreams'>
                                {typeof project.Selected.id !== "undefined" && (loggedUser.data.userRole <= 3 || (loggedUser.data.userRole === 4 && (project.Selected.type.type === "Private" || project.Selected.type.type === "Internal"))) && (
                                    <Workstreams   
                                    triggerEdit={this.triggerEdit}
                                    hasChanges={hasChanges}
                                    isEdit={this.state.isOnEdit}
                                    isOpen={isOpen}
                                    onCancel={()=>{this.setState({onEdit:null})}}
                                    />
                                )}
                            </div>
                            <div ref='calendar'>
                                <Calendar 
                                elemRef="calendar" 
                                projectId={project.Selected.id} 
                                editChange={this.handleEditChanges}
                                hasChanges={this.state.hasChanges}
                                triggerEdit={this.triggerEdit}
                                isEdit={this.state.isOnEdit}
                                isOpen={isOpen}
                                onCancel={()=>{this.setState({onEdit:null})}}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/* Modals */}
                <DeleteModal id="delete-member" type={"member"} type_value={typeValue} delete_function={this.confirmDelete} />
                <NavigationBLocker navigationBlocked={hasChanges.length > 0}/>
                <DiscardChanges onCancel={this.discardCancel} id={'accountSetting'}/>
                <AddWorkstream />
            </div>
        );
    }
}
